// eslint-disable-next-line no-shadow
export enum IPublicEnumTransitionType {

  /** Repaint handling after a node update */
  REPAINT
}

/**
 * @deprecated use IPublicEnumTransitionType instead
 */
export enum TransitionType {

  /** Repaint handling after a node update */
  REPAINT
}